if (!customElements.get("quick-add-modal")) {
  customElements.define(
    "quick-add-modal",
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      }

      hide(preventFocus = false) {
        try {
          const cartNotification =
            document.querySelector("cart-notification") ||
            document.querySelector("cart-drawer");
          if (
            cartNotification &&
            typeof cartNotification.setActiveElement === "function"
          ) {
            cartNotification.setActiveElement(this.openedBy);
          }

          if (this.quickAddAtcLabelObserver) {
            this.quickAddAtcLabelObserver.disconnect();
            this.quickAddAtcLabelObserver = null;
          }

          if (this.quickAddAtcResetTimers?.length) {
            this.quickAddAtcResetTimers.forEach((timerId) =>
              window.clearTimeout(timerId),
            );
            this.quickAddAtcResetTimers = [];
          }

          if (this.modalContent) this.modalContent.innerHTML = "";
          if (preventFocus) this.openedBy = null;
        } finally {
          super.hide();
        }
      }

      show(opener) {
        opener.setAttribute("aria-disabled", true);
        opener.classList.add("loading");
        opener
          .querySelector(".loading-overlay__spinner")
          .classList.remove("hidden");

        fetch(opener.getAttribute("data-product-url"))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(
              responseText,
              "text/html",
            );
            this.productElement = responseHTML.querySelector(
              'section[id^="MainProduct-"]',
            );
            this.preventDuplicatedIDs();
            this.removeDOMElements();
            this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            this.removeGalleryListSemantic();
            this.updateImageSizes();
            this.renderCompactQuickAdd();
            this.preventVariantURLSwitching();
            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute("aria-disabled");
            opener.classList.remove("loading");
            opener
              .querySelector(".loading-overlay__spinner")
              .classList.add("hidden");
          });
      }

      setInnerHTML(element, html) {
        element.innerHTML = html;

        // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
        element.querySelectorAll("script").forEach((oldScriptTag) => {
          const newScriptTag = document.createElement("script");
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(
            document.createTextNode(oldScriptTag.innerHTML),
          );
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
      }

      preventVariantURLSwitching() {
        const variantPicker = this.modalContent.querySelector(
          "variant-radios,variant-selects",
        );
        if (!variantPicker) return;

        variantPicker.setAttribute("data-update-url", "false");
      }

      removeDOMElements() {
        const pickupAvailability = this.productElement.querySelector(
          "pickup-availability",
        );
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = this.productElement.querySelector("product-modal");
        if (productModal) productModal.remove();

        const modalDialog =
          this.productElement.querySelectorAll("modal-dialog");
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset.section;
        this.productElement.innerHTML =
          this.productElement.innerHTML.replaceAll(
            sectionId,
            `quickadd-${sectionId}`,
          );
        this.productElement
          .querySelectorAll("variant-selects, variant-radios, product-info")
          .forEach((element) => {
            element.dataset.originalSection = sectionId;
          });
      }

      removeGalleryListSemantic() {
        const galleryList = this.modalContent.querySelector(
          '[id^="Slider-Gallery"]',
        );
        if (!galleryList) return;

        galleryList.setAttribute("role", "presentation");
        galleryList
          .querySelectorAll('[id^="Slide-"]')
          .forEach((li) => li.setAttribute("role", "presentation"));
      }

      updateImageSizes() {
        const product = this.modalContent.querySelector(".product");
        const desktopColumns = product.classList.contains("product--columns");
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll(".product__media img");
        if (!mediaImages.length) return;

        let mediaImageSizes =
          "(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)";

        if (product.classList.contains("product--medium")) {
          mediaImageSizes = mediaImageSizes.replace("715px", "605px");
        } else if (product.classList.contains("product--small")) {
          mediaImageSizes = mediaImageSizes.replace("715px", "495px");
        }

        mediaImages.forEach((img) =>
          img.setAttribute("sizes", mediaImageSizes),
        );
      }

      renderCompactQuickAdd() {
        const product = this.modalContent.querySelector(".product");
        if (!product) return;

        this.ensureCompactHeader();
        this.keepOnlyFirstImage(product);
        this.removeUnwantedQuickAddElements(product);
        this.keepOnlyEssentialInfo(product);
      }

      ensureCompactHeader() {
        const existingHeader = this.modalContent.querySelector(
          ".quick-add-compact-header",
        );
        if (existingHeader) existingHeader.remove();

        const header = document.createElement("div");
        header.className = "quick-add-compact-header";

        const heading = document.createElement("h3");
        heading.className = "quick-add-compact-heading";
        heading.textContent = "Choose options";

        const closeButton = document.createElement("button");
        closeButton.type = "button";
        closeButton.className = "quick-add-compact-close";
        closeButton.setAttribute("aria-label", "Close quick add");
        closeButton.innerHTML = "&times;";
        closeButton.addEventListener("click", () => this.hide());

        header.appendChild(heading);
        header.appendChild(closeButton);
        this.modalContent.prepend(header);
      }

      removeUnwantedQuickAddElements(product) {
        product
          .querySelectorAll(
            [
              "#prod-rating",
              "#see-similar",
              'div[class^="main__title"]',
              ".form__label",
              ".price_rows",
            ].join(", "),
          )
          .forEach((element) => element.remove());
      }

      keepOnlyFirstImage(product) {
        const mediaList = product.querySelector(
          '[id^="Slider-Gallery"], .product__media-list',
        );
        if (mediaList) {
          const mediaItems = mediaList.querySelectorAll(
            "li, .product__media-item",
          );
          mediaItems.forEach((item, index) => {
            if (index > 0) item.remove();
          });
        }

        product
          .querySelectorAll(
            '.thumbnail-slider, [id^="GalleryThumbnails"], .slider-buttons, .slider-counter',
          )
          .forEach((element) => element.remove());

        const mediaWrappers = product.querySelectorAll(
          ".product__media-wrapper",
        );
        mediaWrappers.forEach((wrapper, index) => {
          if (index > 0) wrapper.remove();
        });
      }

      keepOnlyEssentialInfo(product) {
        const productInfo = product.querySelector("product-info");
        if (!productInfo) return;

        const existingHiddenTitle = productInfo.querySelector("#hidden_title");
        const existingHiddenPrice = productInfo.querySelector("#hidden_price");
        const title = productInfo.querySelector(".product__title");
        const price = productInfo.querySelector('.price_rows, [id^="price-"]');
        const variants = productInfo.querySelector(
          "variant-radios, variant-selects",
        );
        const productForm = productInfo.querySelector("product-form");

        if (productForm) {
          productForm
            .querySelectorAll(
              '.rating, .product__rating, .see-similar, .see-similar-btn, #see-similar, .made-with, .made_with, .made-with-text, .product-made-with, .gift-wrap, .gift-wrap-container, .product-gift, .is-gift, input[name="properties[Is this a gift?]"], label[for*="gift"]',
            )
            .forEach((node) => node.remove());

          const quantity = productForm.querySelector(".product-form__quantity");
          if (quantity) quantity.remove();

          productForm
            .querySelectorAll(
              ".shopify-payment-button, .shopify-payment-button__button",
            )
            .forEach((node) => node.remove());

          const addToCartButton =
            productForm.querySelector('button[name="add"]');
          const buttonWrapper = productForm.querySelector(
            ".product-form__buttons",
          );

          if (buttonWrapper && addToCartButton) {
            buttonWrapper.innerHTML = "";
            buttonWrapper.appendChild(addToCartButton);
          }
        }

        const compactWrapper = document.createElement("div");
        compactWrapper.className = "quick-add-compact-view";

        const hiddenTitleInput =
          existingHiddenTitle ||
          this.createHiddenTrackingInput(
            "hidden_title",
            this.getNodeText(title),
          );
        const hiddenPriceInput =
          existingHiddenPrice ||
          this.createHiddenTrackingInput(
            "hidden_price",
            this.getNodeText(price),
          );

        [title, price].forEach((element) => {
          if (element) compactWrapper.appendChild(element);
        });

        productInfo.replaceChildren(compactWrapper);

        this.moveVariantsAndAtcOutsideDiffBg(
          product,
          variants,
          productForm,
          hiddenTitleInput,
          hiddenPriceInput,
        );

        if (variants) {
          this.setupVariantOptionPrices(variants);
        }

        if (productForm && variants) {
          this.bindVariantChangeAtcMarkupReset(productForm, variants);
        }

        this.syncHiddenTrackingInputs(productInfo);
      }

      createHiddenTrackingInput(id, value) {
        const input = document.createElement("input");
        input.type = "hidden";
        input.id = id;
        input.value = value || "";
        return input;
      }

      bindVariantChangeAtcMarkupReset(productForm, variantsContainer) {
        const initialButton = productForm.querySelector('button[name="add"]');
        if (!initialButton || !variantsContainer) return;

        if (!productForm.dataset.defaultAtcLabelHtml) {
          const labelNode =
            initialButton.querySelector(
              "span:not(.loading-overlay__spinner):not(.visually-hidden)",
            ) || initialButton;
          productForm.dataset.defaultAtcLabelHtml = labelNode.innerHTML;
        }

        const ensureOriginalAtcLabel = () => {
          const button = productForm.querySelector('button[name="add"]');
          if (!button) return;

          if (!this.shouldRestoreAtcLabelNow(productForm)) return;

          const defaultLabelHtml = productForm.dataset.defaultAtcLabelHtml;
          const labelNode =
            button.querySelector(
              "span:not(.loading-overlay__spinner):not(.visually-hidden)",
            ) || button;

          const labelHasSvg = labelNode?.querySelector?.("svg");
          const labelText = (labelNode?.textContent || "").trim().toLowerCase();
          const shouldRestoreLabel =
            Boolean(defaultLabelHtml) &&
            (!labelHasSvg ||
              labelText.includes("added to cart") ||
              labelText === "add to cart");

          if (labelNode && shouldRestoreLabel) {
            labelNode.innerHTML = defaultLabelHtml;
          }
        };

        const resetButtonMarkup = () => {
          const button = productForm.querySelector('button[name="add"]');
          if (!button) return;

          ensureOriginalAtcLabel();

          button.classList.remove(
            "added",
            "added-to-cart",
            "is-added",
            "atc-added",
          );
          button.removeAttribute("aria-disabled");
          if (variantsContainer.currentVariant?.available !== false) {
            button.removeAttribute("disabled");
          }
        };

        const resetWithRetries = () => {
          if (!this.quickAddAtcResetTimers) {
            this.quickAddAtcResetTimers = [];
          }

          this.quickAddAtcResetTimers.forEach((timerId) =>
            window.clearTimeout(timerId),
          );
          this.quickAddAtcResetTimers = [];

          [0, 140, 320, 700].forEach((delay) => {
            const timerId = window.setTimeout(resetButtonMarkup, delay);
            this.quickAddAtcResetTimers.push(timerId);
          });
        };

        if (!variantsContainer.dataset.quickAddAtcMarkupResetBound) {
          variantsContainer.addEventListener("change", () => {
            this.startAtcRestoreWindow(productForm);
            resetWithRetries();
          });
          variantsContainer.dataset.quickAddAtcMarkupResetBound = "true";
        }

        if (!productForm.dataset.quickAddAtcDomObserverBound) {
          this.quickAddAtcLabelObserver?.disconnect();
          this.quickAddAtcLabelObserver = new MutationObserver(() => {
            window.requestAnimationFrame(ensureOriginalAtcLabel);
          });

          this.quickAddAtcLabelObserver.observe(productForm, {
            childList: true,
            subtree: true,
          });

          productForm.dataset.quickAddAtcDomObserverBound = "true";
        }

        ensureOriginalAtcLabel();
      }

      startAtcRestoreWindow(productForm) {
        const now = Date.now();
        productForm.dataset.quickAddAtcRestoreUntil = String(now + 1400);
      }

      shouldRestoreAtcLabelNow(productForm) {
        const restoreUntil = Number(
          productForm.dataset.quickAddAtcRestoreUntil || 0,
        );
        return Date.now() <= restoreUntil;
      }

      getNodeText(node) {
        return node ? (node.textContent || "").trim() : "";
      }

      syncHiddenTrackingInputs(productInfo) {
        const hiddenTitle = this.modalContent.querySelector("#hidden_title");
        const hiddenPrice = this.modalContent.querySelector("#hidden_price");
        if (!hiddenTitle && !hiddenPrice) return;

        const update = () => {
          const currentTitle = productInfo.querySelector(".product__title");
          const currentPrice =
            productInfo.querySelector(".price_rows .price-item--sale") ||
            productInfo.querySelector(".price_rows .price-item--regular") ||
            productInfo.querySelector(".price_rows") ||
            productInfo.querySelector('[id^="price-"]');

          if (hiddenTitle) hiddenTitle.value = this.getNodeText(currentTitle);
          if (hiddenPrice) hiddenPrice.value = this.getNodeText(currentPrice);
        };

        update();

        const variantPicker = this.modalContent.querySelector(
          "variant-radios, variant-selects",
        );
        if (variantPicker && !variantPicker.dataset.quickAddHiddenBound) {
          variantPicker.addEventListener("change", () => {
            window.requestAnimationFrame(update);
          });
          variantPicker.dataset.quickAddHiddenBound = "true";
        }
      }

      moveVariantsAndAtcOutsideDiffBg(
        product,
        variants,
        productForm,
        hiddenTitleInput,
        hiddenPriceInput,
      ) {
        const existingFooter =
          this.modalContent.querySelector(".quick-add-footer");
        if (existingFooter) existingFooter.remove();

        const footer = document.createElement("div");
        footer.className = "quick-add-footer grid__item";

        if (variants) footer.appendChild(variants);
        if (productForm) footer.appendChild(productForm);
        if (hiddenTitleInput) footer.appendChild(hiddenTitleInput);
        if (hiddenPriceInput) footer.appendChild(hiddenPriceInput);

        if (!footer.children.length) return;

        this.modalContent.appendChild(footer);
      }

      setupVariantOptionPrices(variantsContainer) {
        const variantsData = this.getVariantsData(variantsContainer);
        if (!variantsData.length) return;

        const updatePrices = () => {
          if (variantsContainer.tagName.toLowerCase() === "variant-radios") {
            this.renderRadioOptionPrices(variantsContainer, variantsData);
          } else {
            this.renderSelectOptionPrices(variantsContainer, variantsData);
          }
        };

        updatePrices();

        if (!variantsContainer.dataset.quickAddPriceBound) {
          variantsContainer.addEventListener("change", updatePrices);
          variantsContainer.dataset.quickAddPriceBound = "true";
        }
      }

      getVariantsData(variantsContainer) {
        const jsonNode =
          variantsContainer.querySelector('script[type="application/json"]') ||
          this.modalContent.querySelector('script[type="application/json"]');

        if (!jsonNode) return [];

        try {
          const parsed = JSON.parse(jsonNode.textContent || "[]");
          return Array.isArray(parsed) ? parsed : [];
        } catch (e) {
          return [];
        }
      }

      getSelectedOptionValues(variantsContainer) {
        if (variantsContainer.tagName.toLowerCase() === "variant-radios") {
          const fieldsets = variantsContainer.querySelectorAll("fieldset");
          return Array.from(fieldsets).map((fieldset) => {
            const selectedInput = fieldset.querySelector(
              'input[type="radio"]:checked',
            );
            return selectedInput ? selectedInput.value : null;
          });
        }

        const selects = variantsContainer.querySelectorAll("select");
        return Array.from(selects).map((select) => select.value || null);
      }

      findVariantForOption(
        optionIndex,
        optionValue,
        selectedOptions,
        variantsData,
      ) {
        const desiredOptions = [...selectedOptions];
        desiredOptions[optionIndex] = optionValue;

        const exactMatch = variantsData.find((variant) => {
          if (!variant.options || !variant.options.length) return false;
          return desiredOptions.every(
            (value, idx) => !value || variant.options[idx] === value,
          );
        });
        if (exactMatch) return exactMatch;

        const partialMatches = variantsData.filter(
          (variant) =>
            variant.options && variant.options[optionIndex] === optionValue,
        );
        if (!partialMatches.length) return null;

        const availableMatch = partialMatches.find(
          (variant) => variant.available,
        );
        return availableMatch || partialMatches[0];
      }

      renderRadioOptionPrices(variantsContainer, variantsData) {
        const fieldsets = variantsContainer.querySelectorAll("fieldset");
        const selectedOptions = this.getSelectedOptionValues(variantsContainer);

        fieldsets.forEach((fieldset, optionIndex) => {
          const labels = fieldset.querySelectorAll("label[for]");

          labels.forEach((label) => {
            const inputId = label.getAttribute("for");
            if (!inputId) return;

            const input = fieldset.querySelector(`input[id="${inputId}"]`);
            if (!input) return;

            const variant = this.findVariantForOption(
              optionIndex,
              input.value,
              selectedOptions,
              variantsData,
            );
            if (!variant) return;

            let priceNode = label.querySelector(".quick-add-variant-price");
            if (!priceNode) {
              priceNode = document.createElement("div");
              priceNode.className = "quick-add-variant-price";
              label.appendChild(priceNode);
            }

            priceNode.textContent = this.formatMoney(variant.price);
          });
        });
      }

      renderSelectOptionPrices(variantsContainer, variantsData) {
        const selects = variantsContainer.querySelectorAll("select");
        const selectedOptions = this.getSelectedOptionValues(variantsContainer);

        selects.forEach((select, optionIndex) => {
          const options = select.querySelectorAll("option");

          options.forEach((option) => {
            const value = option.value;
            if (!value || value === "null" || value === "") return;

            const variant = this.findVariantForOption(
              optionIndex,
              value,
              selectedOptions,
              variantsData,
            );
            if (!variant) return;

            if (!option.dataset.baseText) {
              option.dataset.baseText = option.textContent
                .split(" - ")[0]
                .trim();
            }

            option.textContent = `${option.dataset.baseText} - ${this.formatMoney(variant.price)}`;
          });
        });
      }

      formatMoney(cents) {
        if (
          window.Shopify &&
          typeof window.Shopify.formatMoney === "function"
        ) {
          const moneyFormat =
            (window.theme && window.theme.moneyFormat) ||
            (window.Shopify && window.Shopify.money_format) ||
            undefined;
          return window.Shopify.formatMoney(cents, moneyFormat);
        }

        const amount = Number(cents || 0) / 100;
        return new Intl.NumberFormat("en-IN", {
          style: "currency",
          currency: "INR",
          maximumFractionDigits: 0,
        }).format(amount);
      }
    },
  );
}
